import { Container, Row, Col } from "reactstrap";

interface ContactProps {
  // When set, renders an honest "not published yet" state for a placeholder
  // route (e.g. /blog) instead of a bare contact form under the wrong label.
  topic?: string;
}

const Contact = ({ topic }: ContactProps) => {
  return (
    <div className="deja-app">
      <Container className="py-5">
        <Row>
          <Col>
            {topic && (
              <>
                <h4 style={{ fontWeight: 700 }}>{topic} — coming soon</h4>
                <p className="text-muted" style={{ maxWidth: 480 }}>
                  We haven&apos;t published this yet. Have a question in the meantime, or want
                  to know when it&apos;s up?
                </p>
              </>
            )}
            <b>Contact</b>:{" "}
            <a href="mailto:contact@dejachart.com?subject=DejaChart">
              contact@dejachart.com
            </a>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Contact;
